import { creatorbase } from '@round/api';
import { CellContext } from '@tanstack/react-table';
import { getTableMetaHelper, Image, SkeletonizedValue } from '@round/ui-kit';
import { ProjectTableMeta } from '../../types';
import styles from './BrandCell.module.css';
import { TooltipOnOverflow } from '@round/whitelabel-ui';

type Row = creatorbase.Project & {
    team: creatorbase.Team | null;
    brand: creatorbase.Brand | null;
};

type Context<T extends Row> = CellContext<T, T['brand']>;
const getTableMeta = getTableMetaHelper<ProjectTableMeta<Row>>();

const BrandCell = <T extends Row>({ getValue, row: { original }, table }: Context<T>) => {
    const { getIsRowLoading, isBrandLoading, isTeamLoading } = getTableMeta(table);

    const team = original.team;
    const brand = getValue();
    const isRowLoading = getIsRowLoading(original);
    const isBrandSkeleton = isRowLoading || (isBrandLoading?.(original) ?? false);
    const isTeamSkeleton = isRowLoading || (isTeamLoading?.(original) ?? false);

    return (
        <div className={styles.container}>
            <Image
                className={styles.image}
                loading={isBrandSkeleton}
                skeletonCircle={false}
                src={brand?.image || ''}
                alt={brand?.name}
            />
            <div className={styles.names}>
                <SkeletonizedValue isInitialized={!isBrandSkeleton}>
                    <TooltipOnOverflow tooltip={brand?.name}>
                        <p key={brand?.name} className={styles.brandName}>
                            {brand?.name}
                        </p>
                    </TooltipOnOverflow>
                </SkeletonizedValue>
                <SkeletonizedValue isInitialized={!isTeamSkeleton} width="75%">
                    <p className={styles.teamName}>{team?.name || '-'}</p>
                </SkeletonizedValue>
            </div>
        </div>
    );
};

export default BrandCell;
